var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import classNames from "classnames";
/**
 * There's an oddity where the input is actually 2-3px taller than the line-height + padding + height
 * so we adjust the bottom pixel by 3px (16px -> 13px) to account for this
 */
export default function TextField(_a) {
    var className = _a.className, _b = _a.type, type = _b === void 0 ? "text" : _b, label = _a.label, error = _a.error, icon = _a.icon, rest = __rest(_a, ["className", "type", "label", "error", "icon"]);
    return (React.createElement("div", { className: "relative flex flex-col rounded-sm " },
        label ? (React.createElement("label", { className: classNames("absolute left-4 top-3 text-xs font-bold capitalize", {
                "text-red": error,
                "text-black-300": !error,
            }) }, label)) : null,
        icon ? (React.createElement("span", { className: "absolute right-4 top-1/2 -translate-y-1/2" }, icon)) : null,
        React.createElement("input", __assign({ type: type, className: classNames("h-14 w-full appearance-none rounded-sm border-none px-4 pb-[13px] pt-6 text-base leading-4 text-black-100 ring-1 placeholder:text-gray-100 focus:outline-none", className, {
                "ring-gray-200 focus:ring-trellis-black": !error,
                "ring-red focus:ring-red": error,
            }) }, rest))));
}
